<template>
	<div>
		<div class="title-container">
			<div class="title">Operations</div>
		</div>
		<div class="grid three">
			<a href @click.prevent="generateModels" class="data">
				<div class="title"><span class="fa fa-signal"></span>Generate Models</div>
				<div class="number big">Execute</div>
			</a>
			<a href @click.prevent="migrateAll" class="data">
				<div class="title"><span class="fa fa-signal"></span>Migrate All</div>
				<div class="number big">Execute</div>
			</a>
			<a href @click.prevent="rollbackAll" class="data">
				<div class="title"><span class="fa fa-signal"></span>Rollback All</div>
				<div class="number big">Execute</div>
			</a>
		</div>
        <div v-if="output" class="input-container">
            <div class="input-static-text">
                <blockquote v-html="output"></blockquote>
            </div>
        </div>
	</div>
</template>

<script>

export default {

	name: 'AdminDashboardPage',

	data() {
		return {
			output: '',
		};
	},

	methods: {

		async generateModels() {
			try {
				const { data } = await this.$api.get('/super/accounts/generate-models/all');
				this.output = data.data.outputs;

				this.$store.dispatch('addToast', 'Models Generated');
			} catch (e) {
				this.$store.dispatch('errorToast', 'Unable to generate models: ' + e.message);
			}
		},

		async migrateAll() {
			try {
				const { data } = await this.$api.get('/super/accounts/migrations/all');
				this.output = data.data.outputs;

				this.$store.dispatch('addToast', 'Migrations Executed');
			} catch (e) {
				this.$store.dispatch('errorToast', 'Unable to migrate all: ' + e.message);
			}
		},

		async rollbackAll() {
			try {
				const { data } = await this.$api.get('/super/accounts/rollback/all');
				this.output = data.data.outputs;

				this.$store.dispatch('addToast', 'Migrations Rolled Back');
			} catch (e) {
				this.$store.dispatch('errorToast', 'Unable to rollback all: ' + e.message);
			}
		},

	},

};

</script>
